import { Component, Inject, ViewChild, Input, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  BaseComponent,
  DialogComponent,
  SnackbarService,
  SnackbarType,
} from 'src/app/shared';
import { AbsenceService } from '../../services/absence.service';
import { IncidentalAbsence } from '../../models/incidental-absence';
import { Session, WorkSchedule, WorkScheduleService } from '../..';
import { WorkWeek } from '../../models/work-week';
import { customvalidations } from 'src/app/shared/models/customvalidations.validator';
import { emulator } from '../../services/emulator.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-incidental-work-schedule-dialog',
    template: `
    <app-dialog
      #submitAbsence
      title="Incidental Work Schedule"
      ariaLabel="Confirmation dialog"
      [width]="1000"
      [showActions]="true"
      [showHeader]="true"
      confirmLabel="Submit"
      btnConfirmAltText="Submit"
      btnConfirmTitleText="Submit"
      cancelLabel="Cancel"
      btnCloseAltText="Cancel"
      btnCloseTitleText="Cancel"
      [showCancel]="!this.submitSuccessful && !submitted"
      [showConfirm]="!this.submitSuccessful && !submitted"
      (confirmEvent)="submit()"
      (cancelEvent)="cancel()"
      >
      <!--       <app-dialog-container
      id="outerDialog"
      class="container"
      > -->
      <app-loading-panel [state]="loading ? 'Loading' : 'Loaded'" [width]="90">
        <ng-template #content>
          <app-http-error
            class="tw-w-full"
            [httpErrorResponse]="null"
          ></app-http-error>
          <form
            [formGroup]="formGroup"
            (ngSubmit)="(null)"
            class="tw-flex tw-flex-wrap tw-w-full"
            style="max-height:450px;"
            >
            @if (!submitSuccessful && !submitted) {
              <div class="tw-w-full app-pb1">
                @if (!userOwnsAbsence) {
                  <a
                  (click)="
                    openClient(
                      absence.empId,
                      absence.firstName + ' ' + absence.lastName,
                      '',
                      absence.empUnum,
                      absence.encryptedEmpId
                    )
                  "
                    >
                    <span
                      >{{ absence.firstName }} {{ absence.lastName }} -
                      {{ absence.empId }}</span
                      >
                    </a>
                  } @else {
                    <b
                      >{{ absence.firstName }} {{ absence.lastName }} -
                      {{ absence.empId }}</b
                      >
                    }
                    <br />
                    <br />
                    {{ 'We need to gather your normal work schedule.' | translation: translationRequest }}<br />
                    <ul>
                      <li>• {{ 'Enter your scheduled hours of work for each day.' | translation: translationRequest }}</li>
                      <li>• {{ 'Use zero hours for any days you are not scheduled.' | translation: translationRequest }}</li>
                      <li>• {{ 'Week 1 represents the current work week.' | translation: translationRequest }}</li>
                      <li>• {{ 'Week 2 represents the following work week.' | translation: translationRequest }}</li>
                    </ul>
                    <br />
                  </div>
                  @for (week of weeks.controls; track week; let i = $index) {
                    <div
                      formArrayName="weeks"
                      class="tw-w-full tw-pt-4"
                      >
                      <div
                        class="tw-w-full tw-flex  tw-flex-wrap tw-pb-4"
                        [formGroupName]="i"
                        >
                        <div class="tw-w-full sm:tw-w-[8%]">
                          <div class="tw-font-bold tw-pt-4">{{ 'Week' | translation: translationRequest }} {{ i + 1 }}</div>
                        </div>
                        <app-text-control
                          formControlName="sun"
                          label="Sunday"
                          validationControl="Sunday"
                          ngDefaultControl
                          [formGroup]="week"
                          mask="separator.2"
                          class="tw-w-[33%] sm:tw-w-[12%]"
                          >
                        </app-text-control>
                        <app-text-control
                          formControlName="mon"
                          label="Monday"
                          validationControl="Monday"
                          ngDefaultControl
                          [formGroup]="week"
                          mask="separator.2"
                          class="tw-w-[33%] sm:tw-w-[12%]"
                          >
                        </app-text-control>
                        <app-text-control
                          formControlName="tue"
                          label="Tuesday"
                          validationControl="Tuesday"
                          ngDefaultControl
                          [formGroup]="week"
                          mask="separator.2"
                          class="tw-w-[33%] sm:tw-w-[12%]"
                          >
                        </app-text-control>
                        <app-text-control
                          formControlName="wed"
                          label="Wednesday"
                          validationControl="Wednesday"
                          ngDefaultControl
                          [formGroup]="week"
                          mask="separator.2"
                          class="tw-w-[33%] sm:tw-w-[12%]"
                          >
                        </app-text-control>
                        <app-text-control
                          formControlName="thu"
                          label="Thursday"
                          validationControl="Thursday"
                          ngDefaultControl
                          [formGroup]="week"
                          mask="separator.2"
                          class="tw-w-[33%] sm:tw-w-[12%]"
                          >
                        </app-text-control>
                        <app-text-control
                          formControlName="fri"
                          label="Friday"
                          validationControl="Friday"
                          ngDefaultControl
                          [formGroup]="week"
                          mask="separator.2"
                          class="tw-w-[33%] sm:tw-w-[12%]"
                          >
                        </app-text-control>
                        <app-text-control
                          formControlName="sat"
                          label="Saturday"
                          validationControl="Saturday"
                          ngDefaultControl
                          [formGroup]="week"
                          mask="separator.2"
                          class="tw-w-[33%] sm:tw-w-[12%]"
                          >
                        </app-text-control>
                        <div class="tw-w-[33%] sm:tw-w-[8%]">
                          <div class="tw-pt-4">
                            <a
                              class="tw-px-1"
                              (keyup.enter)="copyWeek(week)"
                              (click)="copyWeek(week)"
                              tabindex="0"
                              [attr.aria-label]="'Copy week ' + (i + 1)"
                              >{{ 'Copy' | translation: translationRequest }}</a
                              >
                              <a
                                (click)="pasteWeek(week)"
                                (keyup.enter)="pasteWeek(week)"
                                [attr.aria-label]="'Paste into week ' + (i + 1)"
                                tabindex="0"
                                >{{ 'Paste' | translation: translationRequest }}</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    }
                    @if (submitSuccessful && !submitted) {
                      <strong>{{ 'Please review your changes.' | translation: translationRequest }}</strong><br />
                      <p>
                        <strong
                          >{{ absence.firstName }} {{ absence.lastName }} -
                          {{ absence.empId }}</strong
                          >
                        </p>
                        @for (week of weeks.controls; track week; let i = $index) {
                          <div
                            formArrayName="weeks"
                            class="tw-w-full"
                            >
                            <p>
                              <strong>Week {{ i + 1 }}: &nbsp;</strong>
                              SUN: {{ week.get('sun')?.value }} &nbsp; MON:
                              {{ week.get('mon')?.value }} &nbsp; TUE:
                              {{ week.get('tue')?.value }} &nbsp; WED:
                              {{ week.get('wed')?.value }} &nbsp; THU:
                              {{ week.get('thu')?.value }} &nbsp; FRI:
                              {{ week.get('fri')?.value }} &nbsp; SAT:
                              {{ week.get('sat')?.value }} &nbsp;
                            </p>
                          </div>
                        }
                      }
                      @if (submitted && submitSuccessful) {
                        <div class="tw-w-full">
                          <app-toast type="Success">
                            {{ 'Your changes have been submitted and will be available soon.' | translation: translationRequest }}
                          </app-toast>
                        </div>
                      }
                      @if (submitted && !submitSuccessful) {
                        <div class="tw-w-full">
                          <app-toast type="Error"> {{ 'Submission Failed' | translation: translationRequest }} </app-toast>
                        </div>
                      }
                    </form>
                  </ng-template>
                </app-loading-panel>
              <!--       </app-dialog-container> -->
            </app-dialog>
    `,
    styles: [``],
    standalone: false
})
export class IncidentalWorkScheduleDialogComponent
  extends BaseComponent
  implements OnInit
{
  @ViewChild('submitAbsence', { static: false }) submitAbsence: DialogComponent;

  @Input()
  dialogRef: MatDialogRef<any>;

  @Input()
  absence: IncidentalAbsence;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  
  loading: boolean = true;
  userOwnsAbsence: boolean = false;
  formGroup: FormGroup;
  showError: boolean = false;
  responseSuccess: boolean = false;
  response: any;
  copiedWeek: any;
  InvalidDecimalData: string = 'Invalid value';
  schedule: WorkSchedule;
  isReviewing: boolean = true;
  reviewed: boolean = false;
  submitted: boolean = false;
  submitSuccessful: boolean = false;
  submitFail: boolean = false;
  inputValidators: Array<any> = [
    Validators.required,
    Validators.max(20),
    customvalidations.IsNumeric,
  ];

  get weeks(): FormArray<FormGroup> {
    return this.formGroup.get('weeks') as FormArray;
  }

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    public absenceService: AbsenceService,
    public workScheduleService: WorkScheduleService,
    private session: Session,
    private enumalatorService: emulator,
    private snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();

    this.formGroup = this.fb.group({
      program: [null],
      dayOfWeek: [null],
      weeks: this.fb.array([]),
    });
  }

  async ngOnInit(): Promise<void> {
    this.userOwnsAbsence =
      this.session.user.empUnum === this.absence.empUnum ? true : false;

    this.schedule = await this.workScheduleService.GetIncidentalWorkSchedule(
      this.absence.empUnum,
      this.absence.absenceNumber
    );

    let count = 0;
    this.schedule.workWeeks.forEach((_: WorkWeek) => {
      const week = this.fb.group({
        mon: [_.mondayMinutes / 60, this.inputValidators],
        tue: [_.tuesdayMinutes / 60, this.inputValidators],
        wed: [_.wednesdayMinutes / 60, this.inputValidators],
        thu: [_.thursdayMinutes / 60, this.inputValidators],
        fri: [_.fridayMinutes / 60, this.inputValidators],
        sat: [_.saturdayMinutes / 60, this.inputValidators],
        sun: [_.sundayMinutes / 60, this.inputValidators],
      });
      this.weeks.push(week);
      count++;
    });

    // show at least two weeks (max set at server)
    const min = 2;
    for (let c = count; c < min; c++) {
      const week = this.fb.group({
        mon: [null, this.inputValidators],
        tue: [null, this.inputValidators],
        wed: [null, this.inputValidators],
        thu: [null, this.inputValidators],
        fri: [null, this.inputValidators],
        sat: [null, this.inputValidators],
        sun: [null, this.inputValidators],
      });
      this.weeks.push(week);
    }

    this.loading = false;
  }

  copyWeek(week: FormGroup) {
    this.copiedWeek = week.value;
  }

  pasteWeek(week: FormGroup) {
    if (this.copiedWeek) {
      week.setValue(this.copiedWeek);
    }
  }

  async submit() {
    if (this.enumalatorService.showAuditorInfo()) {
      this.dialogRef.close();
      this.snackbarService.show(
        'Preview only mode. Information not sent',
        SnackbarType.Info
      );
      return;
    } else {
      for (let w = 0; w < this.weeks.value.length; w++) {
        this.schedule.workWeeks[w].mondayMinutes = Math.floor(
          this.weeks.value[w].mon * 60
        );
        this.schedule.workWeeks[w].tuesdayMinutes = Math.floor(
          this.weeks.value[w].tue * 60
        );
        this.schedule.workWeeks[w].wednesdayMinutes = Math.floor(
          this.weeks.value[w].wed * 60
        );
        this.schedule.workWeeks[w].thursdayMinutes = Math.floor(
          this.weeks.value[w].thu * 60
        );
        this.schedule.workWeeks[w].fridayMinutes = Math.floor(
          this.weeks.value[w].fri * 60
        );
        this.schedule.workWeeks[w].saturdayMinutes = Math.floor(
          this.weeks.value[w].sat * 60
        );
        this.schedule.workWeeks[w].sundayMinutes = Math.floor(
          this.weeks.value[w].sun * 60
        );
      }
      await this.workScheduleService.UpdateIncidentalWorkSchedule(
        this.schedule,
        this.absence.empUnum
      );
      this.submitted = true;
      this.submitSuccessful = true;
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  /*   review() {
    if (this.formGroup.valid) {
      this.isReviewing = true;
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  back() {
    this.isReviewing = false;
  } */

  openClient(
    empId: string,
    empName: string,
    hrMasterUid: string,
    empUnum: string,
    encryptedEmployeeId: string
  ) {
    this.absenceService.navigateToAbsences(empId, empName, hrMasterUid, empUnum, encryptedEmployeeId);
    this.dialog.closeAll();
  }
}
